// // src/data/servicesData.js

// // Импортируем переводы как JSON
// import translation from '../i18n/locales/ru/translation.json';

// export const createServicesDatabase = () => {
//   const t = translation; // теперь это объект, а не функция
  
//   const servicesList = [];

//   // ============= ОСНОВНЫЕ РАЗДЕЛЫ =============
//   servicesList.push(
//     {
//       id: 'main',
//       title: 'Главная',
//       keywords: ['главная', 'меню', 'основная'],
//       category: 'Раздел',
//       icon: '🏠',
//       page: 'main',
//       action: 'onOpenMain'
//     },
//     {
//       id: 'price',
//       title: t.pricePage?.title || 'Прайс-лист',
//       keywords: ['прайс', 'цены', 'стоимость', 'прайслист', 'ценник', 'услуги'],
//       category: 'Раздел',
//       icon: '📋',
//       page: 'price',
//       action: 'onOpenPrice'
//     },
//     {
//       id: 'healthCheck',
//       title: t.mainPage?.checkup || 'Медосмотры',
//       keywords: ['медосмотр', 'медицинский осмотр', 'медкомиссия', 'профосмотр', 'осмотр', 'чекап'],
//       category: 'Раздел',
//       icon: '🏥',
//       page: 'healthCheck',
//       action: 'onOpenHealthCheck'
//     },
//     {
//       id: 'doctors',
//       title: 'Врачи',
//       keywords: ['врачи', 'доктора', 'специалисты', 'специалист', 'прием', 'консультация'],
//       category: 'Раздел',
//       icon: '👨‍⚕️',
//       page: 'doctors',
//       action: 'onOpenDoctors'
//     },
//     {
//       id: 'faq',
//       title: t.faqPage?.title || 'Часто задаваемые вопросы',
//       keywords: ['вопросы', 'faq', 'часто задаваемые вопросы', 'помощь', 'справка', 'инструкция', 'ответы'],
//       category: 'Раздел',
//       icon: '❓',
//       page: 'faq',
//       action: 'onOpenFaq'
//     },
//     {
//       id: 'reviews',
//       title: t.reviewPage?.title || 'Отзывы',
//       keywords: ['отзывы', 'рейтинг', 'оставить отзыв', 'мнение', 'оценка', 'отзыв'],
//       category: 'Раздел',
//       icon: '⭐',
//       page: 'review',
//       action: 'onOpenReview'
//     },
//     {
//       id: 'contacts',
//       title: t.mainPage?.contacts || 'Контакты',
//       keywords: ['контакты', 'адрес', 'телефон', 'где находимся', 'связь', 'локация'],
//       category: 'Раздел',
//       icon: '📞',
//       page: 'contacts',
//       action: 'handleOpenContacts'
//     },
//     {
//       id: 'support',
//       title: t.mainPage?.support || 'Поддержка',
//       keywords: ['поддержка', 'помощь', 'техподдержка', 'консультация', 'чат', 'вопрос'],
//       category: 'Раздел',
//       icon: '🆘',
//       page: 'support',
//       action: 'handleOpenSupport'
//     }
//   );

//   // ============= ЛУЧЕВАЯ ДИАГНОСТИКА =============
//   servicesList.push(
//     {
//       id: 'radiology',
//       title: t.radiologyPage?.welcome || 'Лучевая диагностика',
//       keywords: ['лучевая', 'радиология', 'диагностика', 'обследование'],
//       category: 'Раздел',
//       icon: '📡',
//       page: 'radiology',
//       action: 'onOpenRadiology'
//     },
//     {
//       id: 'ct',
//       title: t.ctPage?.welcome || 'Компьютерная томография',
//       keywords: ['кт', 'компьютерная томография', 'томография', 'сканер', 'компьютерная'],
//       category: 'Услуга',
//       icon: '🖥️',
//       parent: 'Лучевая диагностика',
//       page: 'ct',
//       action: 'onOpenCT'
//     },
//     {
//       id: 'xray',
//       title: t.xrayPage?.welcome || 'Рентгенография',
//       keywords: ['рентген', 'рентгенография', 'флюорография', 'снимок', 'рентгеновский'],
//       category: 'Услуга',
//       icon: '📸',
//       parent: 'Лучевая диагностика',
//       page: 'xray',
//       action: 'onOpenXRay'
//     },
//     {
//       id: 'mri',
//       title: t.mriPage?.welcome || 'МРТ',
//       keywords: ['мрт', 'магнитно-резонансная томография', 'томография', 'магнитный'],
//       category: 'Услуга',
//       icon: '🧲',
//       parent: 'Лучевая диагностика',
//       page: 'mri',
//       action: 'onOpenMRI'
//     }
//   );

//   // Добавляем конкретные услуги КТ
//   if (t.ctPage?.services) {
//     Object.entries(t.ctPage.services).forEach(([key, value]) => {
//       if (key !== 'back') {
//         servicesList.push({
//           id: `ct-${key}`,
//           title: value,
//           keywords: [value, key, 'кт', 'томография'].filter(Boolean),
//           category: 'Услуга КТ',
//           icon: '📊',
//           parent: 'Компьютерная томография',
//           page: 'ct',
//           action: 'onOpenCT',
//           serviceKey: key
//         });
//       }
//     });
//   }

//   // Добавляем конкретные услуги рентгена
//   if (t.xrayPage?.services) {
//     Object.entries(t.xrayPage.services).forEach(([key, value]) => {
//       if (key !== 'back') {
//         servicesList.push({
//           id: `xray-${key}`,
//           title: value,
//           keywords: [value, key, 'рентген', 'снимок'].filter(Boolean),
//           category: 'Услуга рентгена',
//           icon: '📸',
//           parent: 'Рентгенография',
//           page: 'xray',
//           action: 'onOpenXRay',
//           serviceKey: key
//         });
//       }
//     });
//   }

//   // Добавляем конкретные услуги МРТ
//   if (t.mriPage?.services) {
//     Object.entries(t.mriPage.services).forEach(([key, value]) => {
//       if (key !== 'back') {
//         servicesList.push({
//           id: `mri-${key}`,
//           title: value,
//           keywords: [value, key, 'мрт', 'томография'].filter(Boolean),
//           category: 'Услуга МРТ',
//           icon: '🧲',
//           parent: 'МРТ',
//           page: 'mri',
//           action: 'onOpenMRI',
//           serviceKey: key
//         });
//       }
//     });
//   }

//   // ============= ЛАБОРАТОРНАЯ ДИАГНОСТИКА =============
//   servicesList.push(
//     {
//       id: 'lab',
//       title: t.labPage?.welcome || 'Лабораторная диагностика',
//       keywords: ['лаборатория', 'анализы', 'лабораторные исследования', 'анализ', 'исследования', 'кровь', 'моча'],
//       category: 'Раздел',
//       icon: '🔬',
//       page: 'lab',
//       action: 'onOpenLab'
//     },
//     {
//       id: 'microscopy',
//       title: t.microscopyPage?.welcome || 'Микроскопические исследования',
//       keywords: ['микроскопия', 'грибки', 'кандида', 'дерматофиты', 'ногти', 'кожа', 'волосы'],
//       category: 'Услуга',
//       icon: '🦠',
//       parent: 'Лаборатория',
//       page: 'microscopy',
//       action: 'onOpenMicroscopy'
//     },
//     {
//       id: 'microscopyUro',
//       title: t.microscopyUroPage?.welcome || 'Микроскопия урогенитальная',
//       keywords: ['урогенитальная', 'мазок', 'флора', 'влагалище', 'уретра', 'цервикальный'],
//       category: 'Услуга',
//       icon: '🦠',
//       parent: 'Лаборатория',
//       page: 'microscopyUro',
//       action: 'onOpenMicroscopyUro'
//     },
//     {
//       id: 'clinical',
//       title: t.clinicalPage?.welcome || 'Клинические исследования',
//       keywords: ['клинические', 'моча', 'кал', 'анализ мочи', 'анализ кала', 'энтеробиоз'],
//       category: 'Услуга',
//       icon: '🧪',
//       parent: 'Лаборатория',
//       page: 'clinical',
//       action: 'onOpenClinical'
//     },
//     {
//       id: 'blood',
//       title: t.bloodPage?.welcome || 'Клинический анализ крови',
//       keywords: ['кровь', 'анализ крови', 'гематология', 'гемоглобин', 'лейкоциты', 'эритроциты', 'соэ'],
//       category: 'Услуга',
//       icon: '💉',
//       parent: 'Лаборатория',
//       page: 'blood',
//       action: 'onOpenBlood'
//     },
//     {
//       id: 'biochemistry',
//       title: t.biochemistryPage?.welcome || 'Биохимический анализ крови',
//       keywords: ['биохимия', 'биохимический', 'холестерин', 'глюкоза', 'креатинин', 'мочевина', 'билирубин'],
//       category: 'Услуга',
//       icon: '🧬',
//       parent: 'Лаборатория',
//       page: 'biochemistry',
//       action: 'onOpenBiochemistry'
//     },
//     {
//       id: 'coagulation',
//       title: t.coagulationPage?.welcome || 'Исследование свертываемости крови',
//       keywords: ['свертываемость', 'коагуляция', 'протромбин', 'фибриноген', 'группа крови'],
//       category: 'Услуга',
//       icon: '🩸',
//       parent: 'Лаборатория',
//       page: 'coagulation',
//       action: 'onOpenCoagulation'
//     },
//     {
//       id: 'serology',
//       title: t.serologyPage?.welcome || 'Серологические исследования',
//       keywords: ['серология', 'сифилис', 'инфекции', 'rpr'],
//       category: 'Услуга',
//       icon: '🦠',
//       parent: 'Лаборатория',
//       page: 'serology',
//       action: 'onOpenSerology'
//     },
//     {
//       id: 'express',
//       title: t.expressPage?.welcome || 'Экспресс-тестирование',
//       keywords: ['экспресс', 'быстрые тесты', 'ковид', 'грипп', 'стрептококк'],
//       category: 'Услуга',
//       icon: '⚡',
//       parent: 'Лаборатория',
//       page: 'express',
//       action: 'onOpenExpress'
//     },
//     {
//       id: 'cytology',
//       title: t.cytologyPage?.welcome || 'Цитология',
//       keywords: ['цитология', 'риноцитограмма', 'шейка матки', 'клетки'],
//       category: 'Услуга',
//       icon: '🔬',
//       parent: 'Лаборатория',
//       page: 'cytology',
//       action: 'onOpenCytology'
//     }
//   );

//   // ============= ВРАЧИ ИЗ DOCTORSPAGE =============
//   const doctors = [
//     {
//       id: 1,
//       specialty: t.doctorsPage?.doctors?.ent?.specialty || 'Оториноларинголог',
//       name: t.doctorsPage?.doctors?.ent?.name || 'Магомедов Руслан Валерикович',
//       photo: "/doctors/doctor1.jpg",
//       icon: '👂',
//       keywords: ['лор', 'отоларинголог', 'ухо', 'горло', 'нос', 'магомедов', 'руслан']
//     },
//     {
//       id: 2,
//       specialty: t.doctorsPage?.doctors?.pediatrician?.specialty || 'Педиатр',
//       name: t.doctorsPage?.doctors?.pediatrician?.name || 'Меньшова Татьяна Александровна',
//       photo: "/doctors/doctor2.jpg",
//       icon: '👶',
//       keywords: ['педиатр', 'детский', 'дети', 'ребенок', 'меньшова', 'татьяна']
//     },
//     {
//       id: 3,
//       specialty: t.doctorsPage?.doctors?.psychiatrist?.specialty || 'Психиатр',
//       name: t.doctorsPage?.doctors?.psychiatrist?.name || 'Куклина Анна Михайловна',
//       photo: "/doctors/doctor3.jpg",
//       icon: '🧠',
//       keywords: ['психиатр', 'психотерапевт', 'нарколог', 'куклина', 'анна']
//     },
//     {
//       id: 4,
//       specialty: t.doctorsPage?.doctors?.dermatologist?.specialty || 'Дерматолог',
//       name: t.doctorsPage?.doctors?.dermatologist?.name || 'Рауашде Карина Раедовна',
//       photo: "/doctors/doctor4.jpg",
//       icon: '🌸',
//       keywords: ['дерматолог', 'кожа', 'акне', 'рауашде', 'карина']
//     },
//     {
//       id: 5,
//       specialty: t.doctorsPage?.doctors?.ophthalmologist?.specialty || 'Офтальмолог',
//       name: t.doctorsPage?.doctors?.ophthalmologist?.name || 'Юсупова Чаманора Ашуралиевна',
//       photo: "/doctors/doctor5.jpg",
//       icon: '👁️',
//       keywords: ['офтальмолог', 'глаз', 'зрение', 'юсупова', 'чаманора']
//     },
//     {
//       id: 6,
//       specialty: t.doctorsPage?.doctors?.dentist?.specialty || 'Стоматолог',
//       name: t.doctorsPage?.doctors?.dentist?.name || 'Суслов Игорь Михайлович',
//       photo: "/doctors/doctor6.jpg",
//       icon: '🦷',
//       keywords: ['стоматолог', 'зуб', 'зубы', 'суслов', 'игорь']
//     },
//     {
//       id: 7,
//       specialty: t.doctorsPage?.doctors?.neurologist?.specialty || 'Невролог',
//       name: t.doctorsPage?.doctors?.neurologist?.name || 'Сиразов Зуфар Саубанович',
//       photo: "/doctors/doctor7.jpg",
//       icon: '⚡',
//       keywords: ['невролог', 'головная боль', 'сиразов', 'зуфар']
//     },
//     {
//       id: 8,
//       specialty: 'Психолог',
//       name: 'Чеховская Елизавета Александровна',
//       photo: "/doctors/doctor10.jpg",
//       icon: '🧠',
//       keywords: ['психолог', 'чеховская', 'елизавета']
//     },
//     {
//       id: 9,
//       specialty: 'Психиатр',
//       name: 'Корлякова Алина Дмитриевна',
//       photo: "/doctors/doctor9.jpg",
//       icon: '🧠',
//       keywords: ['психиатр', 'корлякова', 'алина']
//     },
//     {
//       id: 10,
//       specialty: 'Гинеколог',
//       name: 'Гилязова Алия Рамильевна',
//       photo: "/doctors/doctor8.jpg",
//       icon: '👩',
//       keywords: ['гинеколог', 'гилязова', 'алия', 'женский']
//     }
//   ];

//   // Добавляем врачей (только один раз!)
//   doctors.forEach(doctor => {
//     servicesList.push({
//       id: `doctor-${doctor.id}`,
//       title: doctor.name,
//       keywords: [doctor.name, doctor.specialty, ...doctor.keywords],
//       category: 'Врач',
//       icon: doctor.icon,
//       parent: 'Врачи',
//       page: 'doctors',
//       action: 'onOpenDoctors',
//       doctorId: doctor.id,
//       specialty: doctor.specialty,
//       photo: doctor.photo
//     });
//   });

//   // ============= ЧЕКАПЫ =============
//   servicesList.push(
//     {
//       id: 'checkup',
//       title: t.checkupPage?.welcome || 'Check-up программы',
//       keywords: ['check-up', 'чекап', 'комплексное', 'обследование', 'программа'],
//       category: 'Раздел',
//       icon: '📋',
//       page: 'checkup',
//       action: 'onOpenCheckup'
//     },
//     {
//       id: 'maleHealth',
//       title: t.maleHealthPage?.welcome || 'Мужское здоровье',
//       keywords: ['мужское', 'мужчина', 'андрология', 'простата', 'мужской'],
//       category: 'Услуга',
//       icon: '👨',
//       parent: 'Check-up',
//       page: 'maleHealth',
//       action: 'onOpenMaleHealth'
//     },
//     {
//       id: 'femaleHealth',
//       title: t.femaleHealthPage?.welcome || 'Женское здоровье',
//       keywords: ['женское', 'женщина', 'гинекология', 'маммология', 'женский'],
//       category: 'Услуга',
//       icon: '👩',
//       parent: 'Check-up',
//       page: 'femaleHealth',
//       action: 'onOpenFemaleHealth'
//     },
//     {
//       id: 'cardioPrevention',
//       title: t.cardioPreventionPage?.welcome || 'Профилактика СС заболеваний',
//       keywords: ['кардиология', 'сердце', 'сосуды', 'профилактика', 'кардио', 'давление'],
//       category: 'Услуга',
//       icon: '❤️',
//       parent: 'Check-up',
//       page: 'cardioPrevention',
//       action: 'onOpenCardioPrevention'
//     },
//     {
//       id: 'infectionControl',
//       title: t.infectionControlPage?.welcome || 'Инфекционный контроль',
//       keywords: ['инфекции', 'контроль', 'ковид', 'грипп', 'инфекционный'],
//       category: 'Услуга',
//       icon: '🦠',
//       parent: 'Check-up',
//       page: 'infectionControl',
//       action: 'onOpenInfectionControl'
//     }
//   );

//   // ============= ФУНКЦИОНАЛЬНАЯ ДИАГНОСТИКА =============
//   servicesList.push(
//     {
//       id: 'functional',
//       title: t.functionalPage?.welcome || 'Функциональная диагностика',
//       keywords: ['функциональная', 'экг', 'холтер', 'сердце', 'ритм', 'давление', 'кардиограмма'],
//       category: 'Раздел',
//       icon: '📊',
//       page: 'functional',
//       action: 'onOpenFunctional'
//     }
//   );

//   if (t.functionalPage?.services) {
//     Object.entries(t.functionalPage.services).forEach(([key, value]) => {
//       if (key !== 'back' && typeof value === 'string') {
//         servicesList.push({
//           id: `functional-${key}`,
//           title: value,
//           keywords: [value, key, 'экг', 'сердце'].filter(Boolean),
//           category: 'Услуга',
//           icon: '📈',
//           parent: 'Функциональная диагностика',
//           page: 'functional',
//           action: 'onOpenFunctional',
//           serviceKey: key
//         });
//       }
//     });
//   }

//   // ============= КОСМЕТОЛОГИЯ =============
//   servicesList.push(
//     {
//       id: 'cosmetology',
//       title: t.cosmetologyPage?.welcome || 'Косметология',
//       keywords: ['косметология', 'косметолог', 'уход', 'красота', 'кожа', 'лицо'],
//       category: 'Раздел',
//       icon: '💅',
//       page: 'cosmetology',
//       action: 'onOpenCosmetology'
//     },
//     {
//       id: 'removal',
//       title: t.removalPage?.welcome || 'Удаление новообразований',
//       keywords: ['удаление', 'новообразования', 'папиллома', 'бородавка', 'родинка', 'лазер'],
//       category: 'Услуга',
//       icon: '🔪',
//       parent: 'Косметология',
//       page: 'removal',
//       action: 'onOpenRemoval'
//     },
//     {
//       id: 'phototherapy',
//       title: t.phototherapyPage?.welcome || 'Фототерапия',
//       keywords: ['фототерапия', 'светолечение', 'омоложение', 'пигментация', 'лицо'],
//       category: 'Услуга',
//       icon: '💡',
//       parent: 'Косметология',
//       page: 'phototherapy',
//       action: 'onOpenPhototherapy'
//     },
//     {
//       id: 'vesselRemoval',
//       title: t.vesselRemovalPage?.welcome || 'Удаление сосудов',
//       keywords: ['сосуды', 'купероз', 'розацеа', 'сосудистые звездочки', 'гемангиома'],
//       category: 'Услуга',
//       icon: '🩸',
//       parent: 'Косметология',
//       page: 'vesselRemoval',
//       action: 'onOpenVesselRemoval'
//     },
//     {
//       id: 'skinResurfacing',
//       title: t.skinResurfacingPage?.welcome || 'Фракционная шлифовка кожи',
//       keywords: ['шлифовка', 'лазер', 'омоложение', 'рубцы', 'фракционный', 'кожа'],
//       category: 'Услуга',
//       icon: '✨',
//       parent: 'Косметология',
//       page: 'skinResurfacing',
//       action: 'onOpenSkinResurfacing'
//     }
//   );

//   // Добавляем конкретные косметологические услуги
//   const cosmetologyServices = {
//     removal: t.removalPage?.services,
//     phototherapy: t.phototherapyPage?.services,
//     vesselRemoval: t.vesselRemovalPage?.services,
//     skinResurfacing: t.skinResurfacingPage?.services
//   };

//   Object.entries(cosmetologyServices).forEach(([page, services]) => {
//     if (services) {
//       Object.entries(services).forEach(([key, value]) => {
//         if (key !== 'back' && typeof value === 'string') {
//           servicesList.push({
//             id: `${page}-${key}`,
//             title: value,
//             keywords: [value, key, page].filter(Boolean),
//             category: 'Услуга',
//             icon: '✨',
//             parent: page === 'removal' ? 'Удаление новообразований' :
//                    page === 'phototherapy' ? 'Фототерапия' :
//                    page === 'vesselRemoval' ? 'Удаление сосудов' :
//                    page === 'skinResurfacing' ? 'Фракционная шлифовка' : 'Косметология',
//             page: page,
//             action: page === 'removal' ? 'onOpenRemoval' :
//                     page === 'phototherapy' ? 'onOpenPhototherapy' :
//                     page === 'vesselRemoval' ? 'onOpenVesselRemoval' :
//                     page === 'skinResurfacing' ? 'onOpenSkinResurfacing' : 'onOpenCosmetology',
//             serviceKey: key
//           });
//         }
//       });
//     }
//   });

//   console.log('Всего услуг в базе:', servicesList.length);
//   return servicesList;
// };

// // Функция для получения функции действия по имени
// export const getActionByName = (actionName, props) => {
//   const actions = {
//     // Основные
//     onOpenMain: () => {},
//     onOpenPrice: props.onOpenPrice,
//     onOpenHealthCheck: props.onOpenHealthCheck,
//     onOpenDoctors: props.onOpenDoctors,
//     onOpenFaq: props.onOpenFaq,
//     onOpenReview: props.onOpenReview,
//     handleOpenContacts: props.handleOpenContacts,
//     handleOpenSupport: props.handleOpenSupport,
    
//     // Лучевая диагностика
//     onOpenRadiology: props.onOpenRadiology,
//     onOpenCT: props.onOpenCT,
//     onOpenXRay: props.onOpenXRay,
//     onOpenMRI: props.onOpenMRI,
    
//     // Лаборатория
//     onOpenLab: props.onOpenLab,
//     onOpenMicroscopy: props.onOpenMicroscopy,
//     onOpenMicroscopyUro: props.onOpenMicroscopyUro,
//     onOpenClinical: props.onOpenClinical,
//     onOpenBlood: props.onOpenBlood,
//     onOpenBiochemistry: props.onOpenBiochemistry,
//     onOpenCoagulation: props.onOpenCoagulation,
//     onOpenSerology: props.onOpenSerology,
//     onOpenExpress: props.onOpenExpress,
//     onOpenCytology: props.onOpenCytology,
    
//     // Check-up
//     onOpenCheckup: props.onOpenCheckup,
//     onOpenMaleHealth: props.onOpenMaleHealth,
//     onOpenFemaleHealth: props.onOpenFemaleHealth,
//     onOpenCardioPrevention: props.onOpenCardioPrevention,
//     onOpenInfectionControl: props.onOpenInfectionControl,
    
//     // Функциональная диагностика
//     onOpenFunctional: props.onOpenFunctional,
    
//     // Косметология
//     onOpenCosmetology: props.onOpenCosmetology,
//     onOpenRemoval: props.onOpenRemoval,
//     onOpenPhototherapy: props.onOpenPhototherapy,
//     onOpenVesselRemoval: props.onOpenVesselRemoval,
//     onOpenSkinResurfacing: props.onOpenSkinResurfacing,

//     // Врачи
//     onOpenDoctorServices: props.onOpenDoctorServices
//   };

//   return actions[actionName] || null;
// };




// src/data/servicesData.js

// Импортируем переводы как JSON
import translation from '../i18n/locales/ru/translation.json';

export const createServicesDatabase = () => {
  const t = translation; // теперь это объект, а не функция
  
  const servicesList = [];

  // ============= ОСНОВНЫЕ РАЗДЕЛЫ =============
  servicesList.push(
    {
      id: 'main',
      title: 'Главная',
      keywords: ['главная', 'меню', 'основная'],
      category: 'Раздел',
      icon: '🏠',
      page: 'main',
      action: 'onOpenMain'
    },
    {
      id: 'price',
      title: t.pricePage?.title || 'Прайс-лист',
      keywords: ['прайс', 'цены', 'стоимость', 'прайслист', 'ценник', 'услуги'],
      category: 'Раздел',
      icon: '📋',
      page: 'price',
      action: 'onOpenPrice'
    },
    {
      id: 'healthCheck',
      title: t.mainPage?.checkup || 'Медосмотры',
      keywords: ['медосмотр', 'медицинский осмотр', 'медкомиссия', 'профосмотр', 'осмотр', 'чекап'],
      category: 'Раздел',
      icon: '🏥',
      page: 'healthCheck',
      action: 'onOpenHealthCheck'
    },
    {
      id: 'doctors',
      title: 'Врачи',
      keywords: ['врачи', 'доктора', 'специалисты', 'специалист', 'прием', 'консультация'],
      category: 'Раздел',
      icon: '👨‍⚕️',
      page: 'doctors',
      action: 'onOpenDoctors'
    },
    {
      id: 'faq',
      title: t.faqPage?.title || 'Часто задаваемые вопросы',
      keywords: ['вопросы', 'faq', 'часто задаваемые вопросы', 'помощь', 'справка', 'инструкция', 'ответы'],
      category: 'Раздел',
      icon: '❓',
      page: 'faq',
      action: 'onOpenFaq'
    },
    {
      id: 'reviews',
      title: t.reviewPage?.title || 'Отзывы',
      keywords: ['отзывы', 'рейтинг', 'оставить отзыв', 'мнение', 'оценка', 'отзыв'],
      category: 'Раздел',
      icon: '⭐',
      page: 'review',
      action: 'onOpenReview'
    },
    {
      id: 'contacts',
      title: t.mainPage?.contacts || 'Контакты',
      keywords: ['контакты', 'адрес', 'телефон', 'где находимся', 'связь', 'локация'],
      category: 'Раздел',
      icon: '📞',
      page: 'contacts',
      action: 'handleOpenContacts'
    },
    {
      id: 'support',
      title: t.mainPage?.support || 'Поддержка',
      keywords: ['поддержка', 'помощь', 'техподдержка', 'консультация', 'чат', 'вопрос'],
      category: 'Раздел',
      icon: '🆘',
      page: 'support',
      action: 'handleOpenSupport'
    }
  );

  // ============= ЛУЧЕВАЯ ДИАГНОСТИКА =============
  servicesList.push(
    {
      id: 'radiology',
      title: t.radiologyPage?.welcome || 'Лучевая диагностика',
      keywords: ['лучевая', 'радиология', 'диагностика', 'обследование'],
      category: 'Раздел',
      icon: '📡',
      page: 'radiology',
      action: 'onOpenRadiology'
    },
    {
      id: 'ct',
      title: t.ctPage?.welcome || 'Компьютерная томография',
      keywords: ['кт', 'компьютерная томография', 'томография', 'сканер', 'компьютерная'],
      category: 'Услуга',
      icon: '🖥️',
      parent: 'Лучевая диагностика',
      page: 'ct',
      action: 'onOpenCT'
    },
    {
      id: 'xray',
      title: t.xrayPage?.welcome || 'Рентгенография',
      keywords: ['рентген', 'рентгенография', 'флюорография', 'снимок', 'рентгеновский'],
      category: 'Услуга',
      icon: '📸',
      parent: 'Лучевая диагностика',
      page: 'xray',
      action: 'onOpenXRay'
    },
    {
      id: 'mri',
      title: t.mriPage?.welcome || 'МРТ',
      keywords: ['мрт', 'магнитно-резонансная томография', 'томография', 'магнитный'],
      category: 'Услуга',
      icon: '🧲',
      parent: 'Лучевая диагностика',
      page: 'mri',
      action: 'onOpenMRI'
    }
  );

  // Добавляем конкретные услуги КТ
  if (t.ctPage?.services) {
    Object.entries(t.ctPage.services).forEach(([key, value]) => {
      if (key !== 'back') {
        servicesList.push({
          id: `ct-${key}`,
          title: value,
          keywords: [value, key, 'кт', 'томография'].filter(Boolean),
          category: 'Услуга КТ',
          icon: '📊',
          parent: 'Компьютерная томография',
          page: 'ct',
          action: 'onOpenCT',
          serviceKey: key
        });
      }
    });
  }

  // Добавляем конкретные услуги рентгена
  if (t.xrayPage?.services) {
    Object.entries(t.xrayPage.services).forEach(([key, value]) => {
      if (key !== 'back') {
        servicesList.push({
          id: `xray-${key}`,
          title: value,
          keywords: [value, key, 'рентген', 'снимок'].filter(Boolean),
          category: 'Услуга рентгена',
          icon: '📸',
          parent: 'Рентгенография',
          page: 'xray',
          action: 'onOpenXRay',
          serviceKey: key
        });
      }
    });
  }

  // Добавляем конкретные услуги МРТ
  if (t.mriPage?.services) {
    Object.entries(t.mriPage.services).forEach(([key, value]) => {
      if (key !== 'back') {
        servicesList.push({
          id: `mri-${key}`,
          title: value,
          keywords: [value, key, 'мрт', 'томография'].filter(Boolean),
          category: 'Услуга МРТ',
          icon: '🧲',
          parent: 'МРТ',
          page: 'mri',
          action: 'onOpenMRI',
          serviceKey: key
        });
      }
    });
  }

  // ============= ЛАБОРАТОРНАЯ ДИАГНОСТИКА =============
  servicesList.push(
    {
      id: 'lab',
      title: t.labPage?.welcome || 'Лабораторная диагностика',
      keywords: ['лаборатория', 'анализы', 'лабораторные исследования', 'анализ', 'исследования', 'кровь', 'моча'],
      category: 'Раздел',
      icon: '🔬',
      page: 'lab',
      action: 'onOpenLab'
    },
    {
      id: 'microscopy',
      title: t.microscopyPage?.welcome || 'Микроскопические исследования',
      keywords: ['микроскопия', 'грибки', 'кандида', 'дерматофиты', 'ногти', 'кожа', 'волосы'],
      category: 'Услуга',
      icon: '🦠',
      parent: 'Лаборатория',
      page: 'microscopy',
      action: 'onOpenMicroscopy'
    },
    {
      id: 'microscopyUro',
      title: t.microscopyUroPage?.welcome || 'Микроскопия урогенитальная',
      keywords: ['урогенитальная', 'мазок', 'флора', 'влагалище', 'уретра', 'цервикальный'],
      category: 'Услуга',
      icon: '🦠',
      parent: 'Лаборатория',
      page: 'microscopyUro',
      action: 'onOpenMicroscopyUro'
    },
    {
      id: 'clinical',
      title: t.clinicalPage?.welcome || 'Клинические исследования',
      keywords: ['клинические', 'моча', 'кал', 'анализ мочи', 'анализ кала', 'энтеробиоз'],
      category: 'Услуга',
      icon: '🧪',
      parent: 'Лаборатория',
      page: 'clinical',
      action: 'onOpenClinical'
    },
    {
      id: 'blood',
      title: t.bloodPage?.welcome || 'Клинический анализ крови',
      keywords: ['кровь', 'анализ крови', 'гематология', 'гемоглобин', 'лейкоциты', 'эритроциты', 'соэ'],
      category: 'Услуга',
      icon: '💉',
      parent: 'Лаборатория',
      page: 'blood',
      action: 'onOpenBlood'
    },
    {
      id: 'biochemistry',
      title: t.biochemistryPage?.welcome || 'Биохимический анализ крови',
      keywords: ['биохимия', 'биохимический', 'холестерин', 'глюкоза', 'креатинин', 'мочевина', 'билирубин'],
      category: 'Услуга',
      icon: '🧬',
      parent: 'Лаборатория',
      page: 'biochemistry',
      action: 'onOpenBiochemistry'
    },
    {
      id: 'coagulation',
      title: t.coagulationPage?.welcome || 'Исследование свертываемости крови',
      keywords: ['свертываемость', 'коагуляция', 'протромбин', 'фибриноген', 'группа крови'],
      category: 'Услуга',
      icon: '🩸',
      parent: 'Лаборатория',
      page: 'coagulation',
      action: 'onOpenCoagulation'
    },
    {
      id: 'serology',
      title: t.serologyPage?.welcome || 'Серологические исследования',
      keywords: ['серология', 'сифилис', 'инфекции', 'rpr'],
      category: 'Услуга',
      icon: '🦠',
      parent: 'Лаборатория',
      page: 'serology',
      action: 'onOpenSerology'
    },
    {
      id: 'express',
      title: t.expressPage?.welcome || 'Экспресс-тестирование',
      keywords: ['экспресс', 'быстрые тесты', 'ковид', 'грипп', 'стрептококк'],
      category: 'Услуга',
      icon: '⚡',
      parent: 'Лаборатория',
      page: 'express',
      action: 'onOpenExpress'
    },
    {
      id: 'cytology',
      title: t.cytologyPage?.welcome || 'Цитология',
      keywords: ['цитология', 'риноцитограмма', 'шейка матки', 'клетки'],
      category: 'Услуга',
      icon: '🔬',
      parent: 'Лаборатория',
      page: 'cytology',
      action: 'onOpenCytology'
    }
  );

  // ============= ВРАЧИ ИЗ DOCTORSPAGE =============
  const doctors = [
    {
      id: 1,
      specialty: t.doctorsPage?.doctors?.ent?.specialty || 'Оториноларинголог',
      name: t.doctorsPage?.doctors?.ent?.name || 'Магомедов Руслан Валерикович',
      photo: "/doctors/doctor1.jpg",
      icon: '👂',
      keywords: ['лор', 'отоларинголог', 'ухо', 'горло', 'нос', 'магомедов', 'руслан']
    },
    {
      id: 2,
      specialty: t.doctorsPage?.doctors?.pediatrician?.specialty || 'Педиатр',
      name: t.doctorsPage?.doctors?.pediatrician?.name || 'Меньшова Татьяна Александровна',
      photo: "/doctors/doctor2.jpg",
      icon: '👶',
      keywords: ['педиатр', 'детский', 'дети', 'ребенок', 'меньшова', 'татьяна']
    },
    {
      id: 3,
      specialty: t.doctorsPage?.doctors?.psychiatrist?.specialty || 'Психиатр',
      name: t.doctorsPage?.doctors?.psychiatrist?.name || 'Куклина Анна Михайловна',
      photo: "/doctors/doctor3.jpg",
      icon: '🧠',
      keywords: ['психиатр', 'психотерапевт', 'нарколог', 'куклина', 'анна']
    },
    {
      id: 4,
      specialty: t.doctorsPage?.doctors?.dermatologist?.specialty || 'Дерматолог',
      name: t.doctorsPage?.doctors?.dermatologist?.name || 'Рауашде Карина Раедовна',
      photo: "/doctors/doctor4.jpg",
      icon: '🌸',
      keywords: ['дерматолог', 'кожа', 'акне', 'рауашде', 'карина']
    },
    {
      id: 5,
      specialty: t.doctorsPage?.doctors?.ophthalmologist?.specialty || 'Офтальмолог',
      name: t.doctorsPage?.doctors?.ophthalmologist?.name || 'Юсупова Чаманора Ашуралиевна',
      photo: "/doctors/doctor5.jpg",
      icon: '👁️',
      keywords: ['офтальмолог', 'глаз', 'зрение', 'юсупова', 'чаманора']
    },
    {
      id: 6,
      specialty: t.doctorsPage?.doctors?.dentist?.specialty || 'Стоматолог',
      name: t.doctorsPage?.doctors?.dentist?.name || 'Суслов Игорь Михайлович',
      photo: "/doctors/doctor6.jpg",
      icon: '🦷',
      keywords: ['стоматолог', 'зуб', 'зубы', 'суслов', 'игорь']
    },
    {
      id: 7,
      specialty: t.doctorsPage?.doctors?.neurologist?.specialty || 'Невролог',
      name: t.doctorsPage?.doctors?.neurologist?.name || 'Сиразов Зуфар Саубанович',
      photo: "/doctors/doctor7.jpg",
      icon: '⚡',
      keywords: ['невролог', 'головная боль', 'сиразов', 'зуфар']
    },
    {
      id: 8,
      specialty: 'Психолог',
      name: 'Чеховская Елизавета Александровна',
      photo: "/doctors/doctor10.jpg",
      icon: '🧠',
      keywords: ['психолог', 'чеховская', 'елизавета']
    },
    {
      id: 9,
      specialty: 'Психиатр',
      name: 'Корлякова Алина Дмитриевна',
      photo: "/doctors/doctor9.jpg",
      icon: '🧠',
      keywords: ['психиатр', 'корлякова', 'алина']
    },
    {
      id: 10,
      specialty: 'Гинеколог',
      name: 'Гилязова Алия Рамильевна',
      photo: "/doctors/doctor8.jpg",
      icon: '👩',
      keywords: ['гинеколог', 'гилязова', 'алия', 'женский']
    }
  ];

  // Добавляем врачей с действием для открытия страницы конкретного врача
  doctors.forEach(doctor => {
    servicesList.push({
      id: `doctor-${doctor.id}`,
      title: doctor.name,
      // Добавляем в keywords фамилию, имя, отчество по частям для лучшего поиска
      keywords: [
        doctor.name, 
        doctor.specialty, 
        ...doctor.keywords,
        // Добавляем отдельно фамилию (первое слово из имени)
        doctor.name.split(' ')[0],
        // Добавляем транслитерацию специальности
        ...getTransliterationVariants(doctor.specialty)
      ].filter(Boolean),
      category: 'Врач',
      icon: doctor.icon,
      parent: 'Врачи',
      page: 'doctors',
      action: 'onOpenDoctorServices', // Изменено на onOpenDoctorServices
      doctorId: doctor.id,
      specialty: doctor.specialty,
      photo: doctor.photo,
      // Добавляем полную информацию о враче для передачи в DoctorServicesPage
      doctorData: {
        id: doctor.id,
        name: doctor.name,
        specialty: doctor.specialty,
        photo: doctor.photo
      }
    });
  });

  // ============= ЧЕКАПЫ =============
  servicesList.push(
    {
      id: 'checkup',
      title: t.checkupPage?.welcome || 'Check-up программы',
      keywords: ['check-up', 'чекап', 'комплексное', 'обследование', 'программа'],
      category: 'Раздел',
      icon: '📋',
      page: 'checkup',
      action: 'onOpenCheckup'
    },
    {
      id: 'maleHealth',
      title: t.maleHealthPage?.welcome || 'Мужское здоровье',
      keywords: ['мужское', 'мужчина', 'андрология', 'простата', 'мужской'],
      category: 'Услуга',
      icon: '👨',
      parent: 'Check-up',
      page: 'maleHealth',
      action: 'onOpenMaleHealth'
    },
    {
      id: 'femaleHealth',
      title: t.femaleHealthPage?.welcome || 'Женское здоровье',
      keywords: ['женское', 'женщина', 'гинекология', 'маммология', 'женский'],
      category: 'Услуга',
      icon: '👩',
      parent: 'Check-up',
      page: 'femaleHealth',
      action: 'onOpenFemaleHealth'
    },
    {
      id: 'cardioPrevention',
      title: t.cardioPreventionPage?.welcome || 'Профилактика СС заболеваний',
      keywords: ['кардиология', 'сердце', 'сосуды', 'профилактика', 'кардио', 'давление'],
      category: 'Услуга',
      icon: '❤️',
      parent: 'Check-up',
      page: 'cardioPrevention',
      action: 'onOpenCardioPrevention'
    },
    {
      id: 'infectionControl',
      title: t.infectionControlPage?.welcome || 'Инфекционный контроль',
      keywords: ['инфекции', 'контроль', 'ковид', 'грипп', 'инфекционный'],
      category: 'Услуга',
      icon: '🦠',
      parent: 'Check-up',
      page: 'infectionControl',
      action: 'onOpenInfectionControl'
    }
  );

  // ============= ФУНКЦИОНАЛЬНАЯ ДИАГНОСТИКА =============
  servicesList.push(
    {
      id: 'functional',
      title: t.functionalPage?.welcome || 'Функциональная диагностика',
      keywords: ['функциональная', 'экг', 'холтер', 'сердце', 'ритм', 'давление', 'кардиограмма'],
      category: 'Раздел',
      icon: '📊',
      page: 'functional',
      action: 'onOpenFunctional'
    }
  );

  if (t.functionalPage?.services) {
    Object.entries(t.functionalPage.services).forEach(([key, value]) => {
      if (key !== 'back' && typeof value === 'string') {
        servicesList.push({
          id: `functional-${key}`,
          title: value,
          keywords: [value, key, 'экг', 'сердце'].filter(Boolean),
          category: 'Услуга',
          icon: '📈',
          parent: 'Функциональная диагностика',
          page: 'functional',
          action: 'onOpenFunctional',
          serviceKey: key
        });
      }
    });
  }

  // ============= КОСМЕТОЛОГИЯ =============
  servicesList.push(
    {
      id: 'cosmetology',
      title: t.cosmetologyPage?.welcome || 'Косметология',
      keywords: ['косметология', 'косметолог', 'уход', 'красота', 'кожа', 'лицо'],
      category: 'Раздел',
      icon: '💅',
      page: 'cosmetology',
      action: 'onOpenCosmetology'
    },
    {
      id: 'removal',
      title: t.removalPage?.welcome || 'Удаление новообразований',
      keywords: ['удаление', 'новообразования', 'папиллома', 'бородавка', 'родинка', 'лазер'],
      category: 'Услуга',
      icon: '🔪',
      parent: 'Косметология',
      page: 'removal',
      action: 'onOpenRemoval'
    },
    {
      id: 'phototherapy',
      title: t.phototherapyPage?.welcome || 'Фототерапия',
      keywords: ['фототерапия', 'светолечение', 'омоложение', 'пигментация', 'лицо'],
      category: 'Услуга',
      icon: '💡',
      parent: 'Косметология',
      page: 'phototherapy',
      action: 'onOpenPhototherapy'
    },
    {
      id: 'vesselRemoval',
      title: t.vesselRemovalPage?.welcome || 'Удаление сосудов',
      keywords: ['сосуды', 'купероз', 'розацеа', 'сосудистые звездочки', 'гемангиома'],
      category: 'Услуга',
      icon: '🩸',
      parent: 'Косметология',
      page: 'vesselRemoval',
      action: 'onOpenVesselRemoval'
    },
    {
      id: 'skinResurfacing',
      title: t.skinResurfacingPage?.welcome || 'Фракционная шлифовка кожи',
      keywords: ['шлифовка', 'лазер', 'омоложение', 'рубцы', 'фракционный', 'кожа'],
      category: 'Услуга',
      icon: '✨',
      parent: 'Косметология',
      page: 'skinResurfacing',
      action: 'onOpenSkinResurfacing'
    }
  );

  // Добавляем конкретные косметологические услуги
  const cosmetologyServices = {
    removal: t.removalPage?.services,
    phototherapy: t.phototherapyPage?.services,
    vesselRemoval: t.vesselRemovalPage?.services,
    skinResurfacing: t.skinResurfacingPage?.services
  };

  Object.entries(cosmetologyServices).forEach(([page, services]) => {
    if (services) {
      Object.entries(services).forEach(([key, value]) => {
        if (key !== 'back' && typeof value === 'string') {
          servicesList.push({
            id: `${page}-${key}`,
            title: value,
            keywords: [value, key, page].filter(Boolean),
            category: 'Услуга',
            icon: '✨',
            parent: page === 'removal' ? 'Удаление новообразований' :
                   page === 'phototherapy' ? 'Фототерапия' :
                   page === 'vesselRemoval' ? 'Удаление сосудов' :
                   page === 'skinResurfacing' ? 'Фракционная шлифовка' : 'Косметология',
            page: page,
            action: page === 'removal' ? 'onOpenRemoval' :
                    page === 'phototherapy' ? 'onOpenPhototherapy' :
                    page === 'vesselRemoval' ? 'onOpenVesselRemoval' :
                    page === 'skinResurfacing' ? 'onOpenSkinResurfacing' : 'onOpenCosmetology',
            serviceKey: key
          });
        }
      });
    }
  });

  console.log('Всего услуг в базе:', servicesList.length);
  return servicesList;
};

// Вспомогательная функция для генерации вариантов транслитерации специальности
function getTransliterationVariants(text) {
  const variants = [];
  const lowerText = text.toLowerCase();
  
  // Основные варианты транслитерации для популярных специальностей
  const specialtyMap = {
    'педиатр': ['pediatr', 'pediatrician', 'детский'],
    'психолог': ['psiholog', 'psychologist', 'psycho'],
    'психиатр': ['psihiatr', 'psychiatrist'],
    'невролог': ['nevrolog', 'neurologist', 'neuro'],
    'дерматолог': ['dermatolog', 'dermatologist', 'derma'],
    'стоматолог': ['stomatolog', 'dentist', 'dental'],
    'гинеколог': ['ginekolog', 'gynecologist', 'gyn'],
    'офтальмолог': ['oftalmolog', 'ophthalmologist', 'eye'],
    'лор': ['lor', 'ent']
  };
  
  for (const [key, values] of Object.entries(specialtyMap)) {
    if (lowerText.includes(key)) {
      variants.push(...values);
    }
  }
  
  return variants;
}

// Функция для получения функции действия по имени
export const getActionByName = (actionName, props, additionalData = null) => {
  const actions = {
    // Основные
    onOpenMain: () => {},
    onOpenPrice: props.onOpenPrice,
    onOpenHealthCheck: props.onOpenHealthCheck,
    onOpenDoctors: props.onOpenDoctors,
    onOpenFaq: props.onOpenFaq,
    onOpenReview: props.onOpenReview,
    handleOpenContacts: props.handleOpenContacts,
    handleOpenSupport: props.handleOpenSupport,
    
    // Лучевая диагностика
    onOpenRadiology: props.onOpenRadiology,
    onOpenCT: props.onOpenCT,
    onOpenXRay: props.onOpenXRay,
    onOpenMRI: props.onOpenMRI,
    
    // Лаборатория
    onOpenLab: props.onOpenLab,
    onOpenMicroscopy: props.onOpenMicroscopy,
    onOpenMicroscopyUro: props.onOpenMicroscopyUro,
    onOpenClinical: props.onOpenClinical,
    onOpenBlood: props.onOpenBlood,
    onOpenBiochemistry: props.onOpenBiochemistry,
    onOpenCoagulation: props.onOpenCoagulation,
    onOpenSerology: props.onOpenSerology,
    onOpenExpress: props.onOpenExpress,
    onOpenCytology: props.onOpenCytology,
    
    // Check-up
    onOpenCheckup: props.onOpenCheckup,
    onOpenMaleHealth: props.onOpenMaleHealth,
    onOpenFemaleHealth: props.onOpenFemaleHealth,
    onOpenCardioPrevention: props.onOpenCardioPrevention,
    onOpenInfectionControl: props.onOpenInfectionControl,
    
    // Функциональная диагностика
    onOpenFunctional: props.onOpenFunctional,
    
    // Косметология
    onOpenCosmetology: props.onOpenCosmetology,
    onOpenRemoval: props.onOpenRemoval,
    onOpenPhototherapy: props.onOpenPhototherapy,
    onOpenVesselRemoval: props.onOpenVesselRemoval,
    onOpenSkinResurfacing: props.onOpenSkinResurfacing,

    // Врачи - теперь открывает страницу конкретного врача
    onOpenDoctorServices: () => {
      console.log('Вызов onOpenDoctorServices с данными:', additionalData);
      if (props.onOpenDoctorServices && additionalData) {
        // Передаем данные врача в функцию
        props.onOpenDoctorServices(additionalData);
      } else {
        console.warn('onOpenDoctorServices не вызван: нет данных или функции', { 
          hasFunction: !!props.onOpenDoctorServices, 
          hasData: !!additionalData 
        });
      }
    }
  };

  return actions[actionName] || null;
};